export const updateLocation = (data) => {
    return (dispatch, getState)=>{
        if (typeof(data) == 'object' || Array.isArray(data)) {
            dispatch({ type: 'DATA', location: 
            { ...data } })
        } else {
            dispatch({ type: "ERROR", location: [] });
        }
    }
}